import React from 'react'
import "./Complex.css"
import complexbg from "../../../../assets/images/modern/bg.webp"

const Complex = () => {
  return (
    <section className="complex">

      {/* Background */}
      <img src={complexbg} alt="" className="complex-bg" />
      <div className="complex-overlay"></div>

      <div className="complex-container">

        {/* CONTENT */}
        <div className="complex-content">

          <h2>
            A Modern Pharmaceutical <br />
            Manufacturing Complex
          </h2>

          <p>
            Advanced Pharmaceutical Industries (API) manufacturing complex
            is designed to meet modern pharmaceutical production requirements
            and international regulatory expectations.
          </p>

          {/* STATS */}
          <div className="complex-stats">
            <div>
              <h3>5,000 m²</h3>
              <span>Total Facility Area</span>
            </div>

            <div>
              <h3>2,000 m²</h3>
              <span>Dedicated Biologics Building</span>
            </div>
          </div>

          {/* DIVIDER */}
          <div className="complex-line"></div>

          {/* FEATURES */}
          <div className="complex-features">
            <span>EU-GMP Aligned Facility Design</span>
            <span>Multiple Integrated Production Suites</span>
          </div>

        </div>

      </div>

    </section>
  )
}

export default Complex